import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { useQueryClient } from 'react-query'
import { useCreateReport } from 'api/hooks/use-report-builder'

// Create-report dialog: name it and open its builder.
//
// There is deliberately no report-type choice here. Whether a report ends up a grid of charts or a
// headed narrative document is something the assistant establishes from the conversation (asking
// when it is genuinely ambiguous) and sets itself — asking the user to pick before they have said
// anything about the report made them choose a layout for work they had not described yet.
// `folderId` files the new report into the folder the index was showing when Create was pressed.
function NewReportModal({ show, onHide, folderId = null }) {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  const reset = () => {
    setName('')
    setDescription('')
  }

  const handleHide = () => {
    reset()
    onHide()
  }

  const { mutate: createReport, isLoading } = useCreateReport({
    options: {
      onSuccess: (report) => {
        queryClient.invalidateQueries(['reports-builder'])
        reset()
        onHide()
        // Land in the builder with nothing in the way. The assistant is already open there and can
        // create the datasets itself, so opening the data sources picker put a modal over the one
        // thing the user is meant to start with.
        if (report?.id) navigate(`/reports/${report.id}`)
      }
    }
  })

  const handleCreate = (e) => {
    e.preventDefault()
    if (!name.trim()) return
    createReport({ name, description, folder_id: folderId })
  }

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Form onSubmit={handleCreate}>
        <Modal.Header closeButton>
          <Modal.Title className="h5">New report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Q3 Risk Overview"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="What this report covers"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light-primary" onClick={handleHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={!name.trim() || isLoading}>
            Create report
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default NewReportModal
